import React, { useState } from 'react';

function useSheet(initialState) {
	const [isShowing, setIsShowing] = useState(initialState ? initialState : false);

	function toggle() {
		setIsShowing(!isShowing);
	}

	// if (isShowing) {
	// 	document.body.classList.add('o-hidden');
	// } else {
	// 	document.body.classList.remove('o-hidden');
	// }

	return {
		isShowing,
		toggle,
	};
}

export default useSheet;
